// extracted by mini-css-extract-plugin
export default {"title":"DescriptionListItemTitle-title-br1UE"};